//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RepportCollection',
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      form: {
        project_id: this.projectId,
        reason: null,
        description: null
      },
      errors: {
        options: {
          message: []
        }
      },
      options: ["Copyminting", "Explicit Content", "Other" ]
    }
  },
  methods: {
    sendMessage() {
      if (this.form.reason === null) {
        this.errors.options.message = 'The field is required'
        return false
      }

      this.$axios.post('/api/reports/', this.form).then(data => {
        this.form = {
          project_id: this.projectId,
          reason: null,
          description: null
        }
      })

      this.dialog = false
    }
  }
}
